module.exports = __webpack_public_path__ + "assets/img/activity-time-c83c7194.png";